import { useRef, useState } from "react";
import useClickOutside from "../../hooks/useClickOutside";
import { ChevronDown } from "lucide-react";
import DropdownMenu from "../Dropdowns/index";
import UserAuthStore from "../../store/userStore";
import { useGetSpectras } from "../../api/queryHooks";

const SpectraSelectionDropdown = ({
  fromSpace,
  selected,
  onSelect,
  className,
  ...props
}) => {
  const dropdownRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const user = UserAuthStore((state) => state.user);
  const orgId = UserAuthStore((state) => state.orgId);
  const { data: spectrasData, isLoading } = useGetSpectras(orgId, user?.uid);
  const spaces = spectrasData || [];

  const options = [
    ...spaces
      .filter(
        (space) =>
          fromSpace?.space_id !== space.space_id &&
          user?.uid === space?.owner_id
      )
      .map((space) => ({ space_id: space.space_id, name: space.title })),
  ];

  useClickOutside(dropdownRef, () => setIsOpen(false));

  return (
    <div
      ref={dropdownRef}
      className={`relative cursor-pointer bg-fill-hex-fafbfe dark:bg-fill-navigation-surface-dark w-full text-xs text-ink-ink dark:text-ink-white border border-edge-hex-aaaaaa dark:border-edge-hex-aaaaaa80 rounded-[10px] ${className}`}
      {...props}
    >
      {isOpen && (
        <DropdownMenu
          options={options}
          isLoading={isLoading}
          onSelect={(model) => {
            onSelect(model);
            setIsOpen(false);
          }}
        />
      )}
      <div
        className="p-[10px] flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="flex-grow font-semibold truncate select-none text-ink-control-border">
          {selected ? selected.name : "Select Spectra"}
        </span>
        <ChevronDown
          className={`flex-shrink-0 ml-1 transform transition-transform duration-200 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>
    </div>
  );
};

export default SpectraSelectionDropdown;
